export type TextPart = { text: string; strong: boolean };
// Interpret only paired bold markers. All content remains React text, never HTML.
export function splitInlineStrong(value: string): TextPart[] {
  const parts: TextPart[] = [];
  const pattern = /\*\*([^*\n]+)\*\*/g;
  let index = 0;
  for (const match of value.matchAll(pattern)) {
    const position = match.index;
    if (position > index) parts.push({ text: value.slice(index, position), strong: false });
    parts.push({ text: match[1]!, strong: true });
    index = position + match[0].length;
  }
  if (index < value.length) parts.push({ text: value.slice(index), strong: false });
  return parts;
}
